var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "notification-icon-message.ef315315.png","uri@2x": __webpack_public_path__ + "notification-icon-message.e66a0966.png","uri@3x": __webpack_public_path__ + "notification-icon-message.9f611850.png",
    width: 29,
    height: 23
});